<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 100%; max-width: 100vw;':''">
    <q-card-section class="no-padding" v-if="isDialog">
      <q-banner class="bg-blue text-white" inline-actions>
        <template v-slot:action>
          <q-btn flat v-close-popup round icon="close"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :hide-header="$q.screen.lt.md"
          flat
          :rows-per-page-options="[10]"
          :data="details">
        <template v-slot:header>
          <q-tr class="text-subtitle2 text-center">
            <td>طرف معامله</td>
            <td v-if="!$q.screen.lt.md">سفارش</td>
            <td v-if="!$q.screen.lt.md">حواله</td>
            <td>فاکتور</td>
            <td>تاریخ فاکتور</td>
            <td>مبلغ فاکتور</td>
            <td>کل بدهی</td>
            <td></td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr v-if="!$q.screen.lt.md" class="text-center" :props="props">
            <td class="text-center no-padding">
              <q-chip :size="$q.screen.lt.md?'sm':'md'" square :label="props.row.Cs_Name" icon="person" clickable
                      @click="showCustomerInfoDialog(props.row)">
                <q-badge v-if="!isDialog && items.filter(item=>item.Cs_ID === props.row.Cs_ID).length>1" floating
                         color="red"
                         text-color="white" :label="items.filter(item=>item.Cs_ID === props.row.Cs_ID).length"/>
                <q-tooltip v-if="items.filter(item=>item.Cs_ID === props.row.Cs_ID).length>1">
                  <div
                      v-for="(item, index) in items.filter(item => item.Cs_ID === props.row.Cs_ID).map(record => record.Money_Maturity_Date)"
                      :key="index">
                    {{ item }}
                  </div>
                </q-tooltip>
              </q-chip>
            </td>
            <td v-if="!$q.screen.lt.md" class="no-padding">
              <q-chip :size="$q.screen.lt.md?'sm':'md'" square :label="props.row.Order_Num" clickable/>
            </td>
            <td v-if="!$q.screen.lt.md" class="no-padding">
              <q-chip :size="$q.screen.lt.md?'sm':'md'" square :label="props.row.Hava_Num" clickable/>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'sm':'md'" square :label="props.row.Sale_Num"
                      @click="showFactorDetailsDialog(props.row)" clickable/>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'sm':'md'" square :label="props.row.Sale_Date">
                <q-badge
                    v-if="props.row.Initialize && props.row.Initialize>0 && props.row.Sale_PayDay!==props.row.Initialize"
                    class="q-ml-xs" rounded
                    :size="$q.screen.lt.md?'sm':'md'" square
                    :label="props.row.Initialize" color="red" text-color="white"/>
                <q-icon
                    v-if="(props.row.Initialize && props.row.Initialize>0) &&
                (props.row.Sale_PayDay && props.row.Sale_PayDay>0) &&
                props.row.Sale_PayDay!==props.row.Initialize" name="arrow_back"/>
                <q-badge rounded :size="$q.screen.lt.md?'sm':'md'" square
                         :label="props.row.Sale_PayDay" v-if="props.row.Sale_PayDay && props.row.Sale_PayDay>0"/>
              </q-chip>
              <q-space/>
            </td>
            <td>
              <q-chip v-if="props.row.Sale_Pay && props.row.Sale_Pay>0" :size="$q.screen.lt.md?'sm':'md'" square
                      color="red" text-color="white"
                      :label="props.row.Sale_Pay.toLocaleString()">
                <q-tooltip content-style="background-color: transparent">
                  <q-card flat>
                    <q-card-section>
                      <q-chip square color="indigo" text-color="white"
                              v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v))" label="اختلاف با خرید">
                        <q-badge class="q-ml-xs" :label="props.row.DiffPay.toLocaleString()" color="red"
                                 text-color="white"/>
                      </q-chip>
                    </q-card-section>
                  </q-card>
                </q-tooltip>
              </q-chip>
              <q-space/>
              <q-chip v-if="props.row.Sale_PayReceive && props.row.Sale_PayReceive>0" :size="$q.screen.lt.md?'sm':'md'"
                      square color="green" text-color="white"
                      :label="props.row.Sale_PayReceive.toLocaleString()">
                <q-tooltip>
                  مبلغ پرداخت شده تاکنون
                </q-tooltip>
              </q-chip>
            </td>
            <td dir="ltr">
              <q-chip
                  square
                  :color="props.row.RemCredit>0?'red-10':'green-10'"
                  :label="props.row.RemCredit ? Math.abs(props.row.RemCredit).toLocaleString():0"
                  text-color="white">
                <q-tooltip>
                  {{ props.row.RemCredit > 0 ? 'بدهکار' : 'بستانکار' }}
                </q-tooltip>
              </q-chip>
            </td>
            <td :style="!isDialog?'width: 200px':''">
              <div :id="`actionRow-${props.row.Sale_Num}`">
                <q-btn
                    v-if="items.filter(item=>item.Cs_ID === props.row.Cs_ID).length>1 && !isDialog"
                    padding="none"
                    round
                    color="indigo"
                    icon="info"
                    @click="$emit('customer-details', props.row)">
                  <q-tooltip>
                    کلیه فاکتورهای طرف معامله
                  </q-tooltip>
                </q-btn>
                <q-btn round flat icon="timeline" color="indigo"
                       @click="showOrderTimeLine(props.row)">
                  <q-tooltip>
                    رهگیری سفارش نهایی نشده
                  </q-tooltip>
                </q-btn>
                <q-btn
                    v-if="props.row.Sale_PayReceive !== props.row.Sale_Pay && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                    flat
                    round
                    color="green"
                    icon="attach_money">
                  <q-tooltip>
                    ثبت رسید پرداخت
                  </q-tooltip>
                  <q-popup-edit
                      buttons
                      persistent
                      cover
                      v-model="props.row.Sale_PayReceive"
                      @save="(val) => setMoneyBack(val, props.row)"
                  >
                    <q-field
                        v-model="props.row.Sale_PayReceive"
                        mask="currency"
                        label="مبلغ دریافتی"
                        label-color="indigo"
                        autofocus
                        filled
                        dir="ltr"
                        lazy-rules
                        :rules="[
                              val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ دریافتی را وارد نمایید',
                              val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ دریافتی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value)"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <q-input dir="ltr" filled v-model="props.row.Sale_PayDate" mask="date" :rules="['date']"
                             label="تاریخ پرداخت" clearable>
                      <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                          <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="props.row.Sale_PayDate" calendar="persian">
                              <div class="row items-center justify-center">
                                <q-btn v-close-popup label="تایید" color="primary" flat/>
                                <q-btn v-close-popup @click="setToDay(props.row)" label="امروز" color="primary"
                                       flat/>
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </q-popup-edit>
                </q-btn>
                <q-btn color="teal" icon="email" @click="showSMSPanel(props.row)" round flat/>
              </div>
            </td>
          </q-tr>
          <q-tr v-if="$q.screen.lt.md" :props="props">
            <q-card>
              <q-card-section class="no-padding">
                <q-chip square :label="props.row.Cs_Name" icon="person" clickable
                        @click="showCustomerInfoDialog(props.row)"/>
                <q-space/>
                <q-chip square :label="props.row.Sale_Num"
                        @click="showFactorDetailsDialog(props.row)" clickable/>
                <q-chip square :label="props.row.Sale_Date">
                  <q-badge class="q-ml-xs" rounded :size="$q.screen.lt.md?'sm':'md'" square
                           :label="props.row.Sale_PayDay"/>
                </q-chip>
                <q-chip square color="red" text-color="white" v-if="props.row.Sale_Pay && props.row.Sale_Pay>0"
                        :label="props.row.Sale_Pay.toLocaleString()" clickable/>
                <q-chip
                    square
                    :color="props.row.RemCredit>0?'red-10':'green-10'"
                    :label="props.row.RemCredit ? Math.abs(props.row.RemCredit).toLocaleString():0"
                    text-color="white">
                  <q-tooltip>
                    {{ props.row.RemCredit > 0 ? 'بدهکار' : 'بستانکار' }}
                  </q-tooltip>
                </q-chip>
              </q-card-section>
              <q-card-actions class="no-padding">
                <q-btn
                    v-if="props.row.Sale_PayReceive < props.row.Sale_Pay && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                    flat
                    round
                    color="green"
                    icon="attach_money">
                  <q-tooltip>
                    ثبت رسید پرداخت
                  </q-tooltip>
                  <q-popup-edit
                      persistent
                      buttons
                      v-model="props.row.Sale_PayReceive"
                      @save="(val) => setMoneyBack(val, props.row)"
                  >
                    <q-field
                        v-model="props.row.Sale_PayReceive"
                        mask="currency"
                        label="مبلغ دریافتی"
                        label-color="indigo"
                        autofocus
                        filled
                        dir="ltr"
                        lazy-rules
                        :rules="[
                              val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ دریافتی را وارد نمایید',
                              val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ دریافتی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value)"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <q-input dir="ltr" filled v-model="props.row.Sale_PayDate" mask="date" :rules="['date']"
                             label="تاریخ پرداخت" clearable>
                      <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                          <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="props.row.Sale_PayDate" calendar="persian">
                              <div class="row items-center justify-center">
                                <q-btn v-close-popup @click="props.row.Sale_PayDate = ToJalaliDate(new Date())"
                                       label="امروز" color="primary"
                                       flat/>
                                <q-btn v-close-popup label="تایید" color="primary" flat/>
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </q-popup-edit>
                </q-btn>
                <q-btn color="teal" icon="email" @click="showSMSPanel(props.row)" round flat/>
                <q-btn round flat icon="timeline" color="indigo"
                       @click="showOrderTimeLine(props.row)">
                  <q-tooltip>
                    رهگیری سفارش نهایی نشده
                  </q-tooltip>
                </q-btn>
              </q-card-actions>
            </q-card>
            <q-separator/>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog v-model="showCustomerInfo" :maximized="$q.screen.lt.md">
      <CustomerInfo :dialog="true" :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog maximized v-model="showFactorDetails">
      <FactorDetails :sale-state="1" :factor-items="factorItems" :sale-kind="1" :sale-num="selectedSale_Num"/>
    </q-dialog>

    <q-dialog v-model="smsPanel">
      <SMSPanel :customer="selectedCustomer" :share="false"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :remain-ordered="false"
                     :with-change-pay-date-permission="true"
                     :sale-num="selectedSale_Num"
                     :sale-date="selectedSaleDate"
                     @refresh-data="loadData"/>
    </q-dialog>

  </q-card>
</template>

<script>
import CustomerInfo from "@/components/customers/CustomerInfo";
import FactorDetails from "@/components/Factor/FactorDetails";
import SMSPanel from "@/components/callCenter/SMSPanel";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import {mapActions} from "vuex";

export default {
  name: "FinancialClaimsItems",
  components: {OrderTimeLine, SMSPanel, FactorDetails, CustomerInfo},
  props: {
    details: {
      type: []
    },
    items: {
      type: []
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTimeLineDialog: false,
      smsPanel: false,
      showFactorDetails: false,
      selectedSale_Num: '',
      selectedSaleDate: '',
      selectedCustomer: '',
      showCustomerInfo: false,
      factorItems: [],
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions({
      setList: 'Dashboard/getListOfFinancialClaims',
      setCustomer: 'Customers/get_customer_info',
      setFactorItems: 'Orders/getFactorItems',
      MoneyBackAction: 'Orders/receiveFactorPay',
    }),
    setMoneyBack(val, row) {
      if (!val.replaceAll(',', '') || val.replaceAll(',', '') === '0' || !row.Sale_PayDate || row.Sale_PayDate.trim() === '') {
        this.$q.notify({
          message: `کلیه اطلاعات خواسته شده را وارد کنید`,
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.MoneyBackAction({
          saleNum: row.Sale_Num,
          Sale_PayDay: val.replaceAll(',', ''),
          Sale_PayDate: row.Sale_PayDate
        }).then((res) => {
          this.$emit("added-pay", res)
          this.$q.notify({
            message: `رسید پرداخت فاکتور ${row.Sale_Num} ثبت گردید`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_PayReceive = val
        })
      }
    },
    showOrderTimeLine(row) {
      this.selectedSale_Num = row.Order_Num;
      this.selectedSaleDate = row.Sale_Date
      this.showTimeLineDialog = true;
    },
    showSMSPanel(row) {
      this.setCustomer(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.smsPanel = true
      })
    },
    showFactorDetailsDialog(row) {
      this.selectedSale_Num = row.Sale_Num
      this.setFactorItems({
        sale_num: this.selectedSale_Num,
        sale_kind: 1
      }).then((res) => {
        this.factorItems = res
        this.showFactorDetails = true
      })
    },
    showCustomerInfoDialog(row) {
      this.setCustomer(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.showCustomerInfo = true;
      })
    },
    refresh(done) {
      setTimeout(() => {
        this.loadData().then(() => {
          done()
        })
      }, 1000)
    },
    setToDay(rowInfo) {
      rowInfo.Sale_PayDate = this.ToJalaliDate(new Date())
    },
    loadData() {
      this.$emit('refresh-data')
    }
  },
}
</script>

<style scoped>

</style>